module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0141.jpg?v=ba046fe0";